import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewbox="0 0 48 48" fill="none"><path fill="currentColor" d="m18.4 19-6.8 4.6h-4C7.7 20 9 16.7 11 14l.3-.2c.4-.2 1.5-.5 2.8.8l4.3 4.3ZM18.5 28.8l-4.4 4.5c-1.2 1.1-2.3 1-2.7.8a.7.7 0 0 1-.4-.2c-2-2.7-3.3-6-3.4-9.5h4l7 4.4ZM23.6 7.7v9.5c-1.1 0-3 .4-4.5 1.3l-4.4-4.4c-1.2-1.1-1-2.3-.9-2.7 0-.2.2-.3.3-.4 2.6-2 6-3.3 9.5-3.3ZM23.6 30.5v9.9c-3.7-.1-7-1.5-9.8-3.6a.7.7 0 0 1-.2-.3c-.6-1.9 4.7-6 5.7-7.2a10 10 0 0 0 4.3 1.2ZM33.3 14 29 18.6a10 10 0 0 0-4.5-1.3V7.7C28 7.7 31.3 9 34 11l.3.4c.1.4.2 1.6-.9 2.7ZM34.4 36.4c0 .2-.1.3-.3.4-2.6 2.2-6 3.5-9.7 3.6v-9.9c1.1 0 2.8-.3 4.3-1.2l4.7 4.7v.1c1.1 1 1 2 1 2.3ZM40.3 24.4c0 3.6-1.3 6.9-3.3 9.5l-.3.3c-.5.1-1.5.4-2.7-.8L29.5 29c3.2-2.1 4.3-3 7-4.5h3.8ZM40.3 23.6h-3.9L29.6 19c1.6-1.2 5-6.3 7.2-5.1l.2.1c2 2.7 3.3 6 3.3 9.6Z"></path><path fill="currentcolor" d="M43.9 23.6h-2.7A17.1 17.1 0 0 0 24.4 6.8V4.1C35 4.4 43.6 13 44 23.6ZM43.9 24.4A19.8 19.8 0 0 1 24.4 44v-2.7c9.2-.2 16.6-7.6 16.8-16.8h2.7ZM23.6 4.1v2.7A17.1 17.1 0 0 0 6.8 23.6H4.1v-1C5 12.5 13.4 4.3 23.7 4.1ZM23.6 41.2v2.7a19.6 19.6 0 0 1-13.3-5.6C6.6 34.8 4.3 30 4 24.4h2.7C7 33.6 14.4 41 23.6 41.2ZM19.4 24c.1 6 9 6 9.2 0-.1-6-9-6-9.2 0Zm4.6 2.9c-3.8-.1-3.8-5.7 0-5.8 3.8.1 3.8 5.7 0 5.8Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
